
// src/web/components/notifications-tab.jsx

import React from 'react'
import connect from '../../connects/notifications-tab'
import listTheme from 'react-toolbox/lib/list/theme.css'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import Loading from './loading.jsx'
import { InfiniteScroll } from './infinite-scroller';
import NotificationsItem from './notifications-item.jsx'
import classnames from 'classnames'
import wrapedListTheme from './themes/wraped-list.css'

class NotificationsTab extends React.Component {
  fetchNotifications = ()=> !this.props.isFetching && this.props.fetchNotifications(this.props)
  render() {
    const {
      t,
      group_id,
      isFetching,
      isFetchFailed,
      hasMore,
      notifications,
    } = this.props

    if(!isFetchFailed && notifications && notifications.length > 0)
      return(
        <InfiniteScroll pageStart={0}
            element="ul"
            initialLoad={false}
            className={classnames(listTheme.list, wrapedListTheme.list)}
            hasMore={hasMore && !isFetchFailed}
            loadMore={this.fetchNotifications}
            loader={
              notifications &&
              <div style={{ width: '100%', textAlign: 'center'}}>
                <ProgressBar type='circular' mode='indeterminate' multicolor />
              </div>}
            useWindow={false} >
          {notifications && notifications.map((notification)=> 
            <NotificationsItem key={notification.notification_id} notification={notification} group_id={group_id} />
          )}
        </InfiniteScroll>)
    else if(isFetchFailed)
      return (
        <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:通知の取得に失敗しました')}</div>
      )
    else if(!isFetchFailed && !notifications && isFetching)
        return (<Loading />)
    else
        return (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 8}}>
            {t('label:通知がありません')}
          </div>
        )
  }
}

export const RawNotificationsTab = NotificationsTab
export default connect(NotificationsTab)



// WEBPACK FOOTER //
// ./src/web/components/notifications-tab.jsx